import React from 'react';
import { Avatar } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import { getImageUrl } from '../../../services/uploadService';

export interface UserAvatarProps {
  src?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  email?: string;
  size?: number | 'small' | 'default' | 'large';
  style?: React.CSSProperties;
}

const getInitials = (firstName?: string | null, lastName?: string | null, email?: string) => {
  if (firstName && lastName) {
    return `${firstName[0]}${lastName[0]}`.toUpperCase();
  }
  if (firstName) {
    return firstName[0].toUpperCase();
  }
  if (email) {
    return email[0].toUpperCase();
  }
  return undefined;
};

const getSize = (size: UserAvatarProps['size']): number | undefined => {
  if (typeof size === 'number') return size;
  // Pour Ant Design: small=24, default=32, large=40
  return undefined; // Laisse Ant Design gérer les tailles prédéfinies
};

export const UserAvatar: React.FC<UserAvatarProps> = ({
  src,
  firstName,
  lastName,
  email,
  size = 'default',
  style = {},
  ...props
}) => {
  const sizeValue = getSize(size);
  const imageUrl = src ? getImageUrl(src) : undefined;
  const initials = getInitials(firstName, lastName, email);
  
  return (
    <Avatar
      src={imageUrl}
      size={typeof size === 'string' ? size : sizeValue}
      icon={!imageUrl && !initials ? <UserOutlined /> : undefined}
      style={{
        backgroundColor: '#0a543d',
        color: '#fff',
        ...style,
      }}
      {...props}
    >
      {initials}
    </Avatar>
  );
};

export default UserAvatar;
